const skipToContentButton = document.querySelector('.skipToContent button')

skipToContentButton.addEventListener('click', () => {
    document.querySelector('main a, main button').focus()
})